<template>
  <div class="so-loader">
    <span
      v-for="i in 20"
      :key="i"
      class="so-loader__dot"
      :style="'--i:' + i"
    ></span>
    <div class="so-loader__rocket-container">
      <SoIcon icon="rocket" size="x-large" class="so-loader__rocket" />
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoIcon from "./SoIcon.vue"

  export default defineComponent({
    components: { SoIcon },
  })
</script>

<style scoped>
  .so-loader {
    position: relative;
    width: 60px;
    height: 60px;
  }

  .so-loader__dot {
    position: absolute;
    inset: 0;
    transform: rotate(calc(18deg * var(--i)));
  }

  .so-loader__dot:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 8px;
    height: 8px;
    background-color: rgb(var(--v-theme-secondary));
    border-radius: 50%;
    transform: scale(0);
    animation: rocket-loading 2s linear infinite;
    animation-delay: calc(0.1s * var(--i));
  }

  @keyframes rocket-loading {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    10% {
      transform: scale(1.2);
    }
    80%,
    90% {
      transform: scale(0);
      opacity: 0;
    }
  }

  .so-loader__rocket-container {
    position: absolute;
    inset: 0;
    animation: rocket-loading-spin 2s linear infinite;
    animation-delay: -1s;
  }

  .so-loader__rocket {
    position: absolute;
    top: 58%;
    left: 65%;
    transform: rotate(225deg);
  }

  @keyframes rocket-loading-spin {
    0% {
      transform: rotate(10deg);
    }
    100% {
      transform: rotate(370deg);
    }
  }
</style>
